export default __webpack_public_path__ + "static/media/whatsapp.af8aa268.svg";